import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../../api/axios';
import './Admin.css';

export default function AdminDashboardPage() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        API.get('/api/admin/stats')
            .then(res => setStats(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="admin-page"><div className="admin-loading">Loading...</div></div>;

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Admin Dashboard</h1>
            </header>

                <div className="stats-grid">

                    <h2 className="admin-section-title">TODAY</h2>

<div className="stats-grid">
    <StatCard
        label="Daily Visitors"
        value={stats?.daily_visitors}
    />

    <StatCard
        label="Signups Today"
        value={stats?.signups_today}
    />

    <StatCard
        label="Active Users Today"
        value={stats?.active_users_today}
    />

    <StatCard
        label="Likes Today"
        value={stats?.likes_today}
    />

    <StatCard
        label="Matches Today"
        value={stats?.matches_today}
    />

    <StatCard
        label="Messages Today"
        value={stats?.messages_today}
    />

    <StatCard
        label="Profile Views Today"
        value={stats?.profile_views_today}
    />

    <StatCard
        label="New Premium Today"
        value={stats?.new_premium_today}
    />
</div>

    <StatCard
        label="Total Accounts"
        value={stats?.total_users}
    />

    <StatCard
        label="Completed Profiles"
        value={stats?.completed_profiles}
    />

    <StatCard
        label="Incomplete Profiles"
        value={stats?.incomplete_profiles}
    />

    <StatCard
        label="Active Users — 7 Days"
        value={stats?.active_users_7_days}
    />

    <StatCard
        label="Male Members"
        value={stats?.male_members}
    />

    <StatCard
        label="Female Members"
        value={stats?.female_members}
    />

    <StatCard
        label="Signups Today"
        value={stats?.signups_today}
    />

    <StatCard
        label="Active Matches"
        value={stats?.active_matches}
    />

    <StatCard
        label="Premium Users"
        value={stats?.premium_users}
    />

    <StatCard
        label="Total Donations"
        value={
            stats?.total_donations != null
                ? `₦${Number(stats.total_donations).toLocaleString()}`
                : undefined
        }
    />

    <StatCard
        label="Pending Reports"
        value={stats?.pending_reports}
        alert
    />

    <StatCard
        label="Pending Photos"
        value={stats?.pending_photos}
        alert
    />

</div>

            <div className="admin-nav">
                <Link to="/admin/reports" className="admin-nav-link">
                    📋 Reports Queue
                    {stats?.pending_reports > 0 && <span className="badge">{stats.pending_reports}</span>}
                </Link>
                <Link to="/admin/photos" className="admin-nav-link">
                    🖼️ Flagged Photos
                    {stats?.pending_photos > 0 && <span className="badge">{stats.pending_photos}</span>}
                </Link>
                <Link to="/admin/users" className="admin-nav-link">
                    👥 User Management
                </Link>
                                <Link to="/admin/donations" className="admin-nav-link">
                    ❤️ Donations
                </Link>
                <Link to="/admin/broadcast" className="admin-nav-link">
                    📣 Broadcast Email
                </Link>
                <Link to="/admin/billing-resync" className="admin-nav-link">
                    🔄 Resync Subscription
                </Link>
            </div>
        </div>
    );
}

function StatCard({ label, value, alert }) {
    return (
        <div className={`stat-card ${alert && value > 0 ? 'alert' : ''}`}>
            <div className="stat-value">{value ?? '—'}</div>
            <div className="stat-label">{label}</div>
        </div>
    );
}